import { NgModule } from '@angular/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { AmbulanceCardService } from 'app/integration/document/ambulance-card/services/ambulance-card.service';
import { EConsultationReferralService } from 'app/integration/document/services/e-consultation-referral.service';
import { DigiluguReferralService } from 'app/integration/document/services/digilugu-referral.service';
import { CdaPreviewComponent } from 'app/integration/document/cda-preview.component';
import { HedaCoreHospitalComponentsModule } from '@heda/core-hospital-ui';
import { CommonModule } from '@angular/common';
import { ObservationReferralService } from 'app/integration/document/services/observation-referral.service';
import { PolicyProvisionInputComponent } from 'app/integration/document/policy/policy-provision-input.component';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [HedaCoreUtilModule, HedaCoreHospitalComponentsModule, CommonModule, TerminologyLibModule, FormsModule],
  providers: [
    ClinicalDocumentService,
    AmbulanceCardService,
    EConsultationReferralService,
    DigiluguReferralService,
    ObservationReferralService,
  ],
  exports: [CdaPreviewComponent, PolicyProvisionInputComponent],
  declarations: [CdaPreviewComponent, PolicyProvisionInputComponent],
})
export class DocumentLibModule {}
